import { __extends } from "tslib";
import { UpdateEmailChannelRequest, UpdateEmailChannelResponse } from "../models/index";
import { deserializeAws_restJson1UpdateEmailChannelCommand, serializeAws_restJson1UpdateEmailChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateEmailChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateEmailChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateEmailChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateEmailChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateEmailChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateEmailChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateEmailChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateEmailChannelCommand(input, context);
    };
    UpdateEmailChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateEmailChannelCommand(output, context);
    };
    return UpdateEmailChannelCommand;
}($Command));
export { UpdateEmailChannelCommand };
//# sourceMappingURL=UpdateEmailChannelCommand.js.map